import { render } from "./Bot.vue?vue&type=template&id=383a0b47&scoped=true"
import script from "./Bot.vue?vue&type=script&lang=js"
export * from "./Bot.vue?vue&type=script&lang=js"

import "../../../node_modules/@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./Bot.vue?vue&type=style&index=1&id=383a0b47&scoped=true&lang=css"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383a0b47"]])

export default __exports__